import { useRecoilState, useRecoilValue } from "recoil";

import { useRootOutcome } from "./root-outcome.hook";
import { atomRootOutcomes } from "./root-outcomes.atoms";
import { selectorAgency } from "../data/data.selectors";
import { DEFAULT_AGENCY_CODE } from "src/config";
import { useNavigate } from "react-router";
import { Paths } from "src/navigation";

export const useRootOutcomes = () => {
  const [rootOutcomes, saveRootOutcomes] = useRecoilState(atomRootOutcomes);

  const topOutcomeId = Object.keys(rootOutcomes)?.[0] || "";

  const {
    rootOutcome: topRootOutcome,
    removeRootOutcome: removeTopRootOutcome,
  } = useRootOutcome(topOutcomeId);

  const removeRootOutcomes = () => saveRootOutcomes({});

  const agency = useRecoilValue(selectorAgency);
  const navigate = useNavigate();
  const goToLanding = () => {
    const agencyCode =
      agency && agency?.id !== DEFAULT_AGENCY_CODE ? agency?.id : "";
    removeTopRootOutcome();
    navigate(Paths.Landing + "?" + agencyCode);
  };

  return {
    rootOutcomes,
    topRootOutcome,
    removeRootOutcomes,
    removeTopRootOutcome,
    goToLanding,
  };
};
